import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailRibbonLazyFunctions"*/ "./lazyIndex"), { name: "MailRibbonLazyFunctions" });

export const lazyGetAppCheckBoxControlRenderer: LazyAction<typeof lazyIndex.getDefaultCheckBoxRenderer, typeof lazyModule> = new LazyAction(lazyModule, m => m.getDefaultCheckBoxRenderer);

export const lazyGetAppComboBoxControlRenderer: LazyAction<typeof lazyIndex.getDefaultComboBoxRenderer, typeof lazyModule> = new LazyAction(lazyModule, m => m.getDefaultComboBoxRenderer);
